import io from 'socket.io-client';
const env = process.env;
const API = `${env.VUE_APP_BACKEND_URL}`;
const socket = io(API);

export default socket;
